// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  //   Icon,
  //   Dialog,
  //   DialogContent,
  //   DialogActions,
  //   Divider,
  //   Container,
  // TextField,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Divider,
  ListItemIcon,
  Icon,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import AppConfig from "appConfig";
// import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import usePageTitle from "app/pageTitle";

function LocationCheckIns() {
  const pageTitle = "Campaign Location Check-Ins";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [checkinRequests, setCheckinRequests] = useState([]);
  const [selectedCheckInRequest, setSelectedCheckInRequest] = useState(null);
  const [agentCheckIns, setAgentCheckIns] = useState([]);
  // const [selectedAgentCheckIn, setSelectedAgentCheckIn] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/campaigns/locations/${ref}/checkins/init.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCheckinRequests(result.data.data.requests);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (selectedCheckInRequest === null) {
      return;
    }

    // console.log(selectedAgentCheckIn);

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/campaigns/locations/${selectedCheckInRequest}/checkins.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setAgentCheckIns(result.data.data.checkins);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [selectedCheckInRequest]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={3} mb={3}>
        <MDBox mb={3}>
          <MDButton
            startIcon={<Icon>chevron_left</Icon>}
            onClick={() => {
              window.history.back();
            }}
          >
            Back
          </MDButton>
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={5} lg={5}>
              <Card>
                <MDBox px={2} py={2}>
                  <MDBox mb={1}>
                    <MDTypography variant="h6">Check-In Requests</MDTypography>
                  </MDBox>
                  <MDBox mb={3}>
                    <Divider />
                  </MDBox>
                  <MDBox mb={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Select A Request</InputLabel>
                      <Select
                        label="Select A Request"
                        select
                        sx={{
                          width: "100%",
                          padding: "12px",
                          paddingLeft: "3px",
                        }}
                        placeholder="Select a request"
                        onChange={(e) => setSelectedCheckInRequest(e.target.value)}
                      >
                        {checkinRequests.map((req) => (
                          <MenuItem value={req.reference}>
                            <ListItem>
                              <MDBox p={0}>
                                <ListItemText
                                  primary={
                                    <MDTypography variant="caption" fontWeight="regular">
                                      Request: {req.reference}
                                    </MDTypography>
                                  }
                                  secondary={
                                    <MDTypography variant="caption">
                                      <b>Date:</b> {req.created}&nbsp; &nbsp;<b>Grace Period: </b>
                                      {req.grace_period}mins
                                    </MDTypography>
                                  }
                                />
                              </MDBox>
                            </ListItem>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
            <Grid item xs={12} md={7} lg={7}>
              <Card>
                <MDBox p={2}>
                  <MDBox mb={1}>
                    <MDTypography variant="h6">Agent Check-Ins</MDTypography>
                  </MDBox>
                  <MDBox mb={1}>
                    <Divider />
                  </MDBox>
                  <MDBox mt={2} p={1}>
                    {agentCheckIns.length > 0 ? (
                      <List>
                        {agentCheckIns.map((checkin) => (
                          <MDBox mb={3}>
                            <ListItem>
                              <ListItemIcon>
                                <MDBox mr={3}>
                                  <img src={checkin.photo} alt="" width={96} />
                                </MDBox>
                              </ListItemIcon>
                              <ListItemText
                                primary={
                                  <MDTypography variant="subtitle2" fontWeight="regular">
                                    {checkin.agent}
                                  </MDTypography>
                                }
                                secondary={
                                  <MDTypography variant="caption">{checkin.created}</MDTypography>
                                }
                              />
                              <MDBox>
                                <Tooltip title="View On Map">
                                  <MDButton
                                    variant="outlined"
                                    iconOnly
                                    color="warning"
                                    onClick={() => {
                                      const maplink = `https://maps.google.com?q=${checkin.latitude},${checkin.longitude}`;
                                      window.open(maplink, "_blank");
                                    }}
                                  >
                                    <Icon>person_pin</Icon>
                                  </MDButton>
                                </Tooltip>
                              </MDBox>
                            </ListItem>
                          </MDBox>
                        ))}
                      </List>
                    ) : (
                      <MDBox>
                        {selectedCheckInRequest === null ? (
                          <MDTypography variant="caption" fontSize={14}>
                            Select a check-in request to see agent location history
                          </MDTypography>
                        ) : (
                          <MDTypography variant="caption" fontSize={14}>
                            No agents have checked in yet.
                          </MDTypography>
                        )}
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LocationCheckIns;
